export default {
    careGiverData : "",
};
